import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoBriefcase = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Briefcase</title>
    <path
      d="M26.057 10.128H5.942c-1.389 0-2.515 1.097-2.515 2.45v12.245c0 1.352 1.126 2.449 2.515 2.449h20.115c1.388 0 2.514-1.097 2.514-2.45V12.579c0-1.353-1.126-2.45-2.514-2.45ZM11.428 6.7c0-.632.512-1.143 1.143-1.143h6.856c.631 0 1.143.511 1.143 1.143v3.428h-9.142V6.7Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoBriefcase;
